import { mountGuestViewer } from '../../GuestViewer/src/guest-viewer';
import '../../GuestViewer/src/guest-viewer.css';

declare const __BUILD_VERSION__: number;

type ServerVersionResponse = {
    version: number;
};

const buildVersion = __BUILD_VERSION__;
let wasConnected = false;
let serverVersionCompatibilityCheckInFlight: Promise<void> | null = null;
let isVersionMismatchReloadRequested = false;

const guestVersionSurface = document.getElementById('guest-version');
if (guestVersionSurface instanceof HTMLElement) {
    guestVersionSurface.textContent = `v${buildVersion}`;
}

function normalizeServerVersionResponse(payload: unknown): ServerVersionResponse | null {
    if (payload == null || typeof payload !== 'object') {
        return null;
    }

    const candidate = payload as Record<string, unknown>;
    const version = candidate.version;
    if (typeof version !== 'number' || !Number.isInteger(version) || version < 0) {
        return null;
    }

    return { version };
}

async function checkServerVersionCompatibilityCore(): Promise<void> {
    const response = await fetch('/api/version', {
        headers: { Accept: 'application/json' },
        cache: 'no-store'
    });

    if (!response.ok) {
        throw new Error(`Version request failed with status ${response.status}.`);
    }

    const payload = await response.json() as unknown;
    const serverVersion = normalizeServerVersionResponse(payload);
    if (serverVersion == null) {
        throw new Error('Version response payload was malformed.');
    }

    if (serverVersion.version <= buildVersion || isVersionMismatchReloadRequested) {
        return;
    }

    isVersionMismatchReloadRequested = true;
    console.warn(`Client build version ${buildVersion} is older than server version ${serverVersion.version}; reloading.`);
    window.location.reload();
}

function ensureServerVersionCompatibility(): Promise<void> {
    if (serverVersionCompatibilityCheckInFlight != null) {
        return serverVersionCompatibilityCheckInFlight;
    }

    const checkPromise = checkServerVersionCompatibilityCore()
        .catch((error) => {
            console.warn('Failed to verify server version compatibility.', error);
        })
        .finally(() => {
            serverVersionCompatibilityCheckInFlight = null;
        });

    serverVersionCompatibilityCheckInFlight = checkPromise;
    return checkPromise;
}

mountGuestViewer({
    onConnectionChanged: (isConnected) => {
        if (isConnected === wasConnected) {
            return;
        }

        wasConnected = isConnected;
        if (isConnected) {
            void ensureServerVersionCompatibility();
        }
    }
});
